import React from 'react';
import { Badge } from '@mantine/core';
import type { PaymentStatus, TicketStatus, ReferralStage } from '../types';
type BadgeVariant = PaymentStatus | TicketStatus | ReferralStage;
interface StatusBadgeProps {
  status: BadgeVariant;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}
const statusConfig: Record<BadgeVariant, {
  label: string;
  color: string;
  bg: string;
}> = {
  // Payment statuses
  paid: {
    label: 'Paid',
    color: '#10b981',
    bg: '#d1fae5'
  },
  upcoming: {
    label: 'Upcoming',
    color: '#64748b',
    bg: '#f1f5f9'
  },
  overdue: {
    label: 'Overdue',
    color: '#ef4444',
    bg: '#fee2e2'
  },
  // Ticket statuses
  new: {
    label: 'New',
    color: '#3b82f6',
    bg: '#dbeafe'
  },
  'in-progress': {
    label: 'In Progress',
    color: '#f59e0b',
    bg: '#fef3c7'
  },
  resolved: {
    label: 'Resolved',
    color: '#10b981',
    bg: '#d1fae5'
  },
  // Referral stages
  'new-lead': {
    label: 'New Lead',
    color: '#8b5cf6',
    bg: '#ede9fe'
  },
  contacted: {
    label: 'Contacted',
    color: '#3b82f6',
    bg: '#dbeafe'
  },
  'site-visit': {
    label: 'Site Visit',
    color: '#f59e0b',
    bg: '#fef3c7'
  },
  negotiation: {
    label: 'Negotiation',
    color: '#ec4899',
    bg: '#fce7f3'
  },
  'deal-won': {
    label: 'Deal Won',
    color: '#10b981',
    bg: '#d1fae5'
  }
};
export function StatusBadge({
  status,
  size = 'sm'
}: StatusBadgeProps) {
  const config = statusConfig[status];
  return <Badge size={size} radius="xl" variant="filled" styles={{
    root: {
      backgroundColor: config.bg,
      color: config.color,
      fontWeight: 600,
      textTransform: 'capitalize'
    }
  }} data-id="element-114">
      {config.label}
    </Badge>;
}